<template>
  <div>
    <ContentWrapperControl>
      <div class="bg-white p-4 rounded-b-lg shadow border-b mb-4">
        <div class="mb-2 text-md font-bold">
          <span v-text="lang('lbl_0000040') + ', '"></span>
          <span v-text="getName()"></span>!
        </div>
        <div
          v-text="lang('lbl_0000272')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <InfoGroupControl v-bind:title="lang('lbl_0000274')">
        <InfoBarControl
          v-show="tin === null"
          type="to-do"
          v-bind:value="tin"
          v-bind:title="lang('lbl_0000098')"
          icon="papsi_tax.svg"
          :show_border="date_of_birth === null"
          :required="false"
          href="/user/enroll/tin"
        />
        <InfoBarControl
          v-show="date_of_birth === null"
          type="to-do"
          v-bind:value="date_of_birth"
          v-bind:title="lang('lbl_0000105')"
          icon="papsi_date_of_birth.svg"
          :show_border="false"
          :required="false"
          href="/user/enroll/date-of-birth"
        />
      </InfoGroupControl>
      <div>
        <ButtonControl @click="proceed">
          {{ lang("lbl_0000199") }}
        </ButtonControl>
      </div>
      <PrivacyInfoControl />
    </ContentWrapperControl>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import InfoBarControl from "@/components/controls/InfoBarControl.vue";
import InfoGroupControl from "@/components/controls/InfoGroupControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    PrivacyInfoControl,
    InfoBarControl,
    InfoGroupControl,
  },
  data() {
    return {
      show: false,
      name: null,
      tin: null,
      date_of_birth: null,
      otp_login: false,
      pin_login: false,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000291"),
      show: true,
      back: false,
    });

    let state = this.$store.state;
    this.name = state.info.first_name || "";
    this.tin = state.info.tin ?? null;
    this.date_of_birth = state.info.date_of_birth ?? null;
    this.otp_login = state.otp_login;
    this.pin_login = state.pin_login;
  },
  methods: {
    proceed() {
      let state = this.$store.state;
      state.enroll.tin = null;
      state.enroll.date_of_birth = null;
      this.$emit("login");
      this.$router.push("/dashboard");
    },
  },
};
</script>
